export const dark = {
  title: 'dark',
  background: '#181A1B',
  primary: '#E8E6E3',
  background_secundary: '#25282b',
  brand: '#24A159',
}

export const light = {
  title: 'light',
  background: '#FFF',
  primary: '#000',
  background_secundary: '#F5F7FA',
  brand: '#38D35C',
}
